/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Telemedicine_DescriptionInputs */

const en_service_telemedicine_description = /** @type {(inputs: Service_Telemedicine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TELUS Health Virtual Care gives you immediate access to medical consults on your phone, tablet or computer, for both mental and physical health.`)
};

const fr_service_telemedicine_description = /** @type {(inputs: Service_Telemedicine_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TELUS Soins de santé virtuels vous donne un accès immédiat à des consultations médicales sur votre téléphone, tablette ou ordinateur, pour la santé mentale et physique.`)
};

/**
* | output |
* | --- |
* | "TELUS Health Virtual Care gives you immediate access to medical consults on your phone, tablet or computer, for both mental and physical health." |
*
* @param {Service_Telemedicine_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_telemedicine_description = /** @type {((inputs?: Service_Telemedicine_DescriptionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Telemedicine_DescriptionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_telemedicine_description(inputs)
	return fr_service_telemedicine_description(inputs)
});